import { render } from "./GamesView.vue?vue&type=template&id=77d4df28&ts=true"
import script from "./GamesView.vue?vue&type=script&lang=ts"
export * from "./GamesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__